import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ABCService } from '../../ABC/utils/services/ABC.service';
import { Cliente } from '../../ABC/utils/models/ABC';
import Swal from 'sweetalert2';
import { map, startWith } from 'rxjs/operators';
import { ClientePedidoService } from '../../../services/generar-pedido/cliente-pedido.service';
import { AccountStatusService } from '../services/account-status/account-status.service';
import { DataCFDI, DataRegimenFiscal } from '../model/DataAddress';
import { DataBuissness } from '../model/DataBuissness';
import { LoginService } from '../../../services/login/login.service';
import { NotificacionesService } from '../../../services/generar-pedido/cart/notifications/notificaciones.service';
import { SearchModalComponent } from './cart/search-modal/search-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { CartService } from '../../../services/generar-pedido/cart/cart.service';
import { CheckoutService } from './cart/utils/services/checkout.service';
import { environment } from '../../../../environments/environment';
import { EmpresaService } from '../../../services/Empresa/Empresa.service';
import { SwalService } from '../../../services/swal/swal.service';
import { ResumenData } from '../../../core/model/DataCart';
import { A11yModule } from '@angular/cdk/a11y';
@Component({
  selector: 'app-generar-pedido',
  templateUrl: './generar-pedido.component.html',
  styleUrls: ['./generar-pedido.component.scss']
})
export class GenerarPedidoComponent implements OnInit {

  pedido: boolean = false;
  clientes: Cliente[] = []
  clientesFiltrados: Observable<any>;
  clienteSeleccionado = new FormControl('', [Validators.required]);
  sucursalSeleccionada = new FormControl('', [Validators.required])
  cliente$: Cliente;
  kabicoinsCliente: number;
  CFDI$: Observable<DataCFDI>;
  regimenFiscal$: Observable<DataRegimenFiscal>;
  datosEmpresa$: Observable<DataBuissness>;
  detallesCredito: any[] = [];
  empresaId: number;
  mostrarMsgError: boolean = false;
  tipoError: string = '';
  msgError: string = '';

  resumen: ResumenData = {
    subTotalProduct: 0,
    subTotal: 0,
    iva: 0,
    totalRecibido: 0,
    total: 0,
  };

  sucursales: string[] = [];

  sucursalesKabik: string[] = ['Norte'];
  sucursalesLetech: string[] = ['Poza Rica', 'Reynosa', 'Huejutla'];

  constructor(
    private empresaService: EmpresaService,
    private abcService: ABCService,
    private clientePedido: ClientePedidoService,
    private edoCuentaService: AccountStatusService,
    private loginService: LoginService,
    private kabicoinsService: NotificacionesService,
    private serviceCart: CartService,
    private checkout: CheckoutService,
    public searchDialog: MatDialog,
    private swal: SwalService
  ) { }

  ngOnInit(): void {
    this.empresaId = this.empresaService.getEmpresaId();
    this.sucursales = this.empresaId === 1 ? this.sucursalesKabik : this.sucursalesLetech;
    console.log(this.sucursales);
    this.getClientes();

    this.clientesFiltrados = this.clienteSeleccionado.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.clientePedido.cliente$.subscribe((cliente) => {
      this.cliente$ = cliente;
    });

    localStorage.setItem('resumen-cart-login', JSON.stringify(this.resumen));
    localStorage.removeItem('address-envio');
    localStorage.removeItem('address-envio-cedis');
    localStorage.removeItem('tipo-entrega-cedis');
    localStorage.removeItem('tipo-entrega-sucursal');
  }

  ngOnDestroy(): void {
    // this.destroy();
    this.clientePedido.resetCliente();
  }

  getClientes(): void {
    this.abcService.getClientesAbcDos().subscribe((respuesta: any) => {
      if (respuesta.error) {
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: `Ocurrió un error al obtener la información de los clientes. 
          Recargue la pagina o contacte con el administrador.`,
          confirmButtonText: 'Aceptar'
        });
      } else {
        //console.log(respuesta.clientes)
        this.clientes = respuesta.clientes;
      }
    })
  }

  // Guarda el id y nombre del cliente por separado
  onOptionSelected(event: any): void {
    const opcion = event.option.value;
    this.clientePedido.actualizarId(opcion.split('-')[0].trim());
    this.clientePedido.actualizarNombre(opcion.split('-')[1].trim());

    this.validarCliente();
  }

  limpiarDatos(): void {
    this.clienteSeleccionado.reset('');
    this.clientePedido.resetCliente();
    this.msgError = '';
    this.mostrarMsgError = false;
    this.pedido = false;
    this.detallesCredito = [];

    // limpiar tipo-entrega-cedis, tipo-entrega-sucursal, direccion de envio y cedis
    localStorage.removeItem('tipo-entrega-cedis');
    localStorage.removeItem('tipo-entrega-sucursal');
    localStorage.removeItem('address-envio');
    localStorage.removeItem('address-envio-cedis');
    //this.destroy();
  }

  validarCliente(): void {
    this.tipoError = '';
    this.mostrarMsgError = false;
    const clienteId = parseInt(this.cliente$.ClienteID);

    if (this.clienteSeleccionado.valid && clienteId !== undefined && clienteId !== 0) {
      this.CFDI$ = this.edoCuentaService.getUsoCdfi(clienteId);
      this.regimenFiscal$ = this.edoCuentaService.getRegimenFiscal(clienteId);
      this.datosEmpresa$ = this.edoCuentaService.getDataBuissness(clienteId);
      this.loginCliente();
    } else {
      this.clienteSeleccionado.markAllAsTouched()
    }
  }

  mostrarPedido(): void {
    if (this.cliente$.Nombre !== '') {
      this.pedido = true;
    }
  }

  loginCliente(): void {
    const cliente: any = {
      ClienteID: this.cliente$.ClienteID,
      Nombre: this.cliente$.Nombre,
    }

    if (this.msgError !== '') {
      cliente.Sucursal = this.sucursalSeleccionada.value;
    } else {
      cliente.Sucursal = '';
    }

    this.loginService.loginClientePedidos(cliente).subscribe((datosLogin) => {
      // console.log(datosLogin)
      if (datosLogin.message == "true") {
        this.sucursalSeleccionada.setValue('')
        this.obtenerKabicoins();
        this.mostrarPedido();
        this.checkClientCredit();
      } else {
        this.tipoError = datosLogin.tipoError
        this.msgError = datosLogin.message;
        this.mostrarMsgError = true;
        // this.swal.swalAlert('Alerta', datosLogin.message);
      }
    })
  }

  checkClientCredit(): void {
    const clienteId = parseInt(this.cliente$.ClienteID);
    this.edoCuentaService.checkCredit(clienteId).subscribe((credito) => {
      //console.log("credito", credito.resultados);
      this.detallesCredito = credito.resultados;
    });
  }

  obtenerKabicoins(): void {
    this.kabicoinsService.kabikCoins$.pipe().subscribe((res: number) => {
      this.kabicoinsCliente = res;
    })
  }

  recargarPagina() {
    window.location.reload()
  }

  logoutCliente() {
    this.destroy();
    window.location.reload();
  }

  public destroy(): void {
    console.log('destroy');
    localStorage.removeItem('comision-cart-login');
    localStorage.removeItem('resumen-cart-login');
    localStorage.removeItem('envio-cart-login');
    localStorage.removeItem('items-cart-login');
    localStorage.removeItem('address-envio');
    localStorage.removeItem('address-envio-cedis');
    localStorage.removeItem('opcion-metodo-entrega');
    localStorage.removeItem('pasarela-pago');
    localStorage.removeItem('data-pedido');
    localStorage.removeItem('carrito');
    localStorage.removeItem('tipo-pago');
    localStorage.removeItem('tipo-entrega-cedis');
    localStorage.removeItem('tipo-entrega-sucursal');
    localStorage.removeItem('cliente-CFDI');
    localStorage.removeItem('data-operation');
    localStorage.removeItem('data-reference');
    localStorage.removeItem('clientePedidoSession');
    this.serviceCart.guardCheckout = false;
    this.serviceCart.goToCart.next(null);
    this.serviceCart.goToCart.complete();
    this.checkout.completeTipoDeCompra$();
    this.checkout.completeMercanciaSucursal$();
    this.checkout.completeEnvioMercanciaCedis$();
    this.checkout.completeLimiteCredito$();
    this.checkout.completeMetodoPago$();
    this.checkout.completeRecalculaResumen$();
    this.checkout.completeformularioCheckout$();
    this.checkout.completeformularioCheckout$();
    console.log('end destroy');
  }

  openSearch() {
    this.searchDialog.open(SearchModalComponent, {
      width: '2800px',
      panelClass: 'search-product',
    })
  }

  private _filter(valor: string): any {
    const valorFiltro = valor.toLowerCase();
    return this.clientes.filter(option => option.ClienteID.toLowerCase().includes(valorFiltro) ||
      option.Nombre.toLowerCase().includes(valorFiltro));
  }
}